export const getGameHistoryListHTML = (text: string, url: string): string => `
    <div class='title'>${text}</div>
    <div class='close'></div>
    <div class='content'>
        <iframe src=${url}></iframe>
    </div>
`;